$(function () {
  $("#accordion").accordion({
    heightStyle: "content",
    active: true,
    collapsible: false,
  });

  $("#accordion .ui-accordion-content").show();

  $(".open").click(function () {
    $("#accordion .ui-accordion-content").show();
  });
  $(".close").click(function () {
    $("#accordion .ui-accordion-content").hide();
  });
});
